import gtm from '@/utils/gtm';
import { useEffect, useRef } from 'react';
import styles from './index.module.scss';
import EFEmail from '@/components/UI/svg/Footer/Icon/EFEmail';

type BackToBottomProps = {
    /** 离底部剩余多少像素时隐藏按钮，默认 160px */
    hideThreshold?: number;
};
// 滚动到页面底部邮箱订阅
export default function BackToBottom({ hideThreshold = 160 }: BackToBottomProps) {
    const refBottom = useRef<HTMLDivElement | null>(null);

    const toBottomFn = () => {
        if (typeof window === 'undefined' || typeof document === 'undefined') return;
        const docEl = document.documentElement || document.body;
        const scrollHeight = docEl?.scrollHeight || 0;
        window.scrollTo({
            top: scrollHeight,
            behavior: 'smooth',
        });
        gtm.push({
            event: 'uaEvent',
            event_name: 'bottom_function',
            button_name: 'back_to_bottom',
        });
    };

    // useEffect(() => {
    //     if (typeof window === 'undefined') return;
    //     const handleScroll = () => {
    //         const docEl = document.documentElement || document.body;
    //         if (!docEl) return;
    //         const viewportBottom = window.pageYOffset + window.innerHeight;
    //         const remaining = docEl.scrollHeight - viewportBottom;
    //         if (remaining > hideThreshold) {
    //             refBottom.current?.classList?.add(styles.showBottom);
    //         } else {
    //             refBottom.current?.classList?.remove(styles.showBottom);
    //         }
    //     };
    //     window.addEventListener('scroll', handleScroll);
    //     handleScroll();
    //     return () => {
    //         window.removeEventListener('scroll', handleScroll);
    //     };
    // }, [hideThreshold]);

    return (
        <div className={`${styles.backToBottom} ${styles.showBottom}`} ref={refBottom} onClick={toBottomFn}>
            <EFEmail className="form-email" />
        </div>
    );
}

